module.exports = __webpack_public_path__ + "static/img/bg_item2.1a766c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_item2.png
// module id = wsKf
// module chunks = 19